/* eslint-disable react/jsx-no-target-blank */
import {useIntl} from 'react-intl'
import {KTIcon} from '@_metronic/helpers'

import useIsMobileIOSCookieTrue from '@app/hooks/useIsMobileIOSCookieTrue'
import {useAuth} from '@app/modules/auth'

const SidebarFooter = () => {
  const intl = useIntl()
  const {currentUser} = useAuth()

  const isMobileIOSCookieTrue = useIsMobileIOSCookieTrue()

  if (isMobileIOSCookieTrue) return null

  return (
    <div className='app-sidebar-footer flex-column-auto pt-2 pb-6 px-6' id='kt_app_sidebar_footer'>
      <a
        href={`https://jivo.chat/mm2JHN2QIJ${
          currentUser?.email ? `?email=${currentUser.email}` : ''
        }`}
        target='_blank'
        className='btn btn-outline btn-outline-dashed btn-outline-success btn-active-light-success flex-center overflow-hidden text-nowrap px-0 h-40px w-100'
        data-bs-toggle='tooltip'
        data-bs-trigger='hover'
        data-bs-dismiss-='click'
        title='Instructions on how to use the service'
      >
        <KTIcon iconName='document' className='btn-icon fs-2 m-0' />
        <span className='btn-label'>{intl.formatMessage({id: 'FOOTER.SUPPORT'})}</span>
      </a>
    </div>
  )
}

export {SidebarFooter}
